import { v4 } from 'uuid';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { of, timer, EMPTY } from 'rxjs';
import { ApiResolverService } from '@kissmybutton/nsx-ui-api-lib';
import { Injectable } from '@angular/core';
import { Store, createFeatureSelector, createSelector } from '@ngrx/store';
import { distinctUntilChanged, map, switchMap, filter, withLatestFrom, catchError, mergeMap } from 'rxjs/operators';
import { __assign, __rest, __spread, __values, __read, __decorate, __metadata } from 'tslib';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var INIT_COMPONENT = 'INIT_COMPONENT [UI_COMPONENT] ';
/** @type {?} */
var ATTACH_COMPONENT = 'ATTACH_COMPONENT [UI_COMPONENT] ';
/** @type {?} */
var DETACH_COMPONENT = 'DETACH_COMPONENT [UI_COMPONENT] ';
/** @type {?} */
var CONNECT_COMPONENT_WITH_API_DATA = 'CONNECT_COMPONENT_WITH_API_DATA [UI_COMPONENT] ';
/** @type {?} */
var RESTART_POLLING = 'RESTART_POLLING [UI_COMPONENT] ';
/** @type {?} */
var START_POLLING = 'START_POLLING [UI_COMPONENT] ';
/** @type {?} */
var STOP_POLLING = 'STOP_POLLING [UI_COMPONENT] ';
/** @type {?} */
var ATTACH_API_DATA = 'ATTACH_API_DATA [API_DATA] ';
/** @type {?} */
var GET_API_DATA = 'GET_API_DATA [API_DATA] ';
/** @type {?} */
var SET_API_DATA = 'SET_API_DATA [API_DATA] ';
/** @type {?} */
var SET_API_DATA_ERROR = 'SET_API_DATA_ERROR [API_DATA] ';
/** @type {?} */
var SET_API_DATA_SUCCESS = 'SET_API_DATA_SUCCESS [API_DATA] ';
//==================== Component related actions =====================================//
var  
//==================== Component related actions =====================================//
AttachComponent = /** @class */ (function () {
    function AttachComponent(url, component, componentGuid) {
        this.url = url;
        this.component = component;
        this.componentGuid = componentGuid;
        this.type = ATTACH_COMPONENT;
    }
    return AttachComponent;
}());
var DetachComponent = /** @class */ (function () {
    function DetachComponent(componentGuid) {
        this.componentGuid = componentGuid;
        this.type = DETACH_COMPONENT;
    }
    return DetachComponent;
}());
var ConnectComponentWithApiData = /** @class */ (function () {
    function ConnectComponentWithApiData(componentGuid, apiDataGuid) {
        this.componentGuid = componentGuid;
        this.apiDataGuid = apiDataGuid;
        this.type = CONNECT_COMPONENT_WITH_API_DATA;
    }
    return ConnectComponentWithApiData;
}());
var RestartPolling = /** @class */ (function () {
    function RestartPolling(componentGuid) {
        this.componentGuid = componentGuid;
        this.type = RESTART_POLLING;
    }
    return RestartPolling;
}());
var StartPolling = /** @class */ (function () {
    function StartPolling(componentGuid) {
        this.componentGuid = componentGuid;
        this.type = START_POLLING;
    }
    return StartPolling;
}());
var StopPolling = /** @class */ (function () {
    function StopPolling(componentGuid) {
        this.componentGuid = componentGuid;
        this.type = STOP_POLLING;
    }
    return StopPolling;
}());
//==================== API DATA related actions =====================================//
var  
//==================== API DATA related actions =====================================//
AttachApiData = /** @class */ (function () {
    function AttachApiData(apiEndpointGuid, apiEndpointUrl) {
        this.apiEndpointGuid = apiEndpointGuid;
        this.apiEndpointUrl = apiEndpointUrl;
        this.type = ATTACH_API_DATA;
    }
    return AttachApiData;
}());
var GetApiData = /** @class */ (function () {
    function GetApiData(apiEndpointGuid) {
        this.apiEndpointGuid = apiEndpointGuid;
        this.type = GET_API_DATA;
    }
    return GetApiData;
}());
var SetApiData = /** @class */ (function () {
    function SetApiData(apiEndpointGuid, serializedUrl, data) {
        this.apiEndpointGuid = apiEndpointGuid;
        this.serializedUrl = serializedUrl;
        this.data = data;
        this.type = SET_API_DATA;
    }
    return SetApiData;
}());
var SetApiDataError = /** @class */ (function () {
    function SetApiDataError() {
        this.type = SET_API_DATA_ERROR;
    }
    return SetApiDataError;
}());
var SetApiDataSuccess = /** @class */ (function () {
    function SetApiDataSuccess() {
        this.type = SET_API_DATA_SUCCESS;
    }
    return SetApiDataSuccess;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * Generates a random uuid (v4). Use this simple utility to centralize uuid generation
 * We might be interested in changing uuid generation logic in the future
 * @return {?}
 */
function getUuid() {
    return v4();
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AppDispatchers = /** @class */ (function () {
    function AppDispatchers(store, apiResolverService) {
        this.store = store;
        this.apiResolverService = apiResolverService;
    }
    /**
     * @param {?} componentSelector
     * @param {?} endpointType
     * @param {?=} pollingInterval
     * @return {?}
     */
    AppDispatchers.prototype.attachComponent = /**
     * @param {?} componentSelector
     * @param {?} endpointType
     * @param {?=} pollingInterval
     * @return {?}
     */
    function (componentSelector, endpointType, pollingInterval) {
        if (pollingInterval === void 0) { pollingInterval = null; }
        /** @type {?} */
        var item = {
            pollingInterval: pollingInterval,
            polling: false,
            type: componentSelector
        };
        /** @type {?} */
        var endpointConfiguration = this.apiResolverService.resolveApiSettingsFor(componentSelector, endpointType);
        /** @type {?} */
        var guid = getUuid();
        this.store.dispatch(new AttachComponent(endpointConfiguration.url, item, guid));
        return guid;
    };
    /**
     * @param {?} componentGuid
     * @return {?}
     */
    AppDispatchers.prototype.detachComponent = /**
     * @param {?} componentGuid
     * @return {?}
     */
    function (componentGuid) {
        this.store.dispatch(new DetachComponent(componentGuid));
    };
    /**
     * @param {?} componentGuid
     * @return {?}
     */
    AppDispatchers.prototype.startPolling = /**
     * @param {?} componentGuid
     * @return {?}
     */
    function (componentGuid) {
        this.store.dispatch(new StartPolling(componentGuid));
    };
    /**
     * @param {?} componentGuid
     * @return {?}
     */
    AppDispatchers.prototype.restartPolling = /**
     * @param {?} componentGuid
     * @return {?}
     */
    function (componentGuid) {
        this.store.dispatch(new RestartPolling(componentGuid));
    };
    /**
     * @param {?} componentGuid
     * @return {?}
     */
    AppDispatchers.prototype.stopPolling = /**
     * @param {?} componentGuid
     * @return {?}
     */
    function (componentGuid) {
        this.store.dispatch(new StopPolling(componentGuid));
    };
    /**
     * @param {?} apiEndpointGuid
     * @return {?}
     */
    AppDispatchers.prototype.getApiData = /**
     * @param {?} apiEndpointGuid
     * @return {?}
     */
    function (apiEndpointGuid) {
        this.store.dispatch(new GetApiData(apiEndpointGuid));
    };
    AppDispatchers.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AppDispatchers.ctorParameters = function () { return [
        { type: Store },
        { type: ApiResolverService }
    ]; };
    return AppDispatchers;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var getAppState = createFeatureSelector('libState');
/** @type {?} */
var getApiData = createSelector(getAppState, function (state) { return state.uiState.apiData; });
/** @type {?} */
var getUiComponentData = createSelector(getAppState, function (state) {
    return state.uiState.uiComponents;
});
var AppSelectors = /** @class */ (function () {
    function AppSelectors(store) {
        this.store = store;
    }
    Object.defineProperty(AppSelectors.prototype, "appState$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.store.select(getAppState);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppSelectors.prototype, "apiData$", {
        //============================== API DATA selectors ======================================//
        get: 
        //============================== API DATA selectors ======================================//
        /**
         * @return {?}
         */
        function () {
            return this.store.select(getApiData).pipe(distinctUntilChanged());
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} endpointGuid
     * @return {?}
     */
    AppSelectors.prototype.getApiData = /**
     * @param {?} endpointGuid
     * @return {?}
     */
    function (endpointGuid) {
        return this.apiData$.pipe(distinctUntilChanged(), map(function (apiData) { return apiData[endpointGuid]; }));
    };
    /**
     * @param {?} url
     * @return {?}
     */
    AppSelectors.prototype.getApiResultsByUrl = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return this.apiData$.pipe(map(function (apiData) {
            var e_1, _a;
            try {
                for (var _b = __values(Object.keys(apiData)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    if (apiData[key].serializedRequestUrl === url) {
                        return key;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return null;
        }));
    };
    /**
     * @param {?} endpointGuid
     * @return {?}
     */
    AppSelectors.prototype.getApiDataArray = /**
     * @param {?} endpointGuid
     * @return {?}
     */
    function (endpointGuid) {
        return this.getApiData(endpointGuid).pipe(map(function (apiData) { return apiData ? apiData.data : null; }));
    };
    /**
     * @param {?} componentGuid
     * @return {?}
     */
    AppSelectors.prototype.getApiDataLatest = /**
     * @param {?} componentGuid
     * @return {?}
     */
    function (componentGuid) {
        var _this = this;
        return this.getUiComponentEndpoint$(componentGuid).pipe(switchMap(function (endpointGuid) { return _this.getApiData(endpointGuid); }), filter(function (apiData) { return !!apiData.data && !!apiData.data.length; }), map(function (apiData) {
            if (!apiData) {
                return null;
            }
            var _a = apiData.data.length - 1, b = apiData.data[_a];
            return b;
        }));
    };
    Object.defineProperty(AppSelectors.prototype, "uiComponents$", {
        //============================== UI-COMPONENT DATA selectors =============================//
        get: 
        //============================== UI-COMPONENT DATA selectors =============================//
        /**
         * @return {?}
         */
        function () {
            return this.store.select(getUiComponentData).pipe(distinctUntilChanged());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppSelectors.prototype, "uiComponentsNonDistinct$", {
        get: /**
         * @return {?}
         */
        function () {
            return this.store.select(getUiComponentData);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} componentGuid
     * @return {?}
     */
    AppSelectors.prototype.getUiComponent = /**
     * @param {?} componentGuid
     * @return {?}
     */
    function (componentGuid) {
        return this.uiComponents$.pipe(map(function (uiComponentData) { return uiComponentData[componentGuid]; }));
    };
    /**
     * @param {?} compnoentGuid
     * @return {?}
     */
    AppSelectors.prototype.getUiComponentEndpoint$ = /**
     * @param {?} compnoentGuid
     * @return {?}
     */
    function (compnoentGuid) {
        return this.getUiComponent(compnoentGuid).pipe(map(function (uiComponent) {
            return uiComponent ? uiComponent.endpointGuid : null;
        }));
    };
    /**
     * @param {?} compnoentGuid
     * @return {?}
     */
    AppSelectors.prototype.getUiComponentType$ = /**
     * @param {?} compnoentGuid
     * @return {?}
     */
    function (compnoentGuid) {
        return this.getUiComponent(compnoentGuid).pipe(map(function (uiComponent) { return uiComponent ? uiComponent.type : null; }));
    };
    /**
     * @param {?} compnoentGuid
     * @return {?}
     */
    AppSelectors.prototype.getUiComponentPolling$ = /**
     * @param {?} compnoentGuid
     * @return {?}
     */
    function (compnoentGuid) {
        return this.getUiComponent(compnoentGuid).pipe(map(function (uiComponent) { return uiComponent ? uiComponent.polling : null; }));
    };
    AppSelectors.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AppSelectors.ctorParameters = function () { return [
        { type: Store }
    ]; };
    return AppSelectors;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NsxUiEffects = /** @class */ (function () {
    function NsxUiEffects(actions$, selectors, apiResolverService) {
        var _this = this;
        this.actions$ = actions$;
        this.selectors = selectors;
        this.apiResolverService = apiResolverService;
        this.attachComponent$ = this.actions$.pipe(ofType(ATTACH_COMPONENT), withLatestFrom(this.selectors.apiData$), map(function (_a) {
            var _b = __read(_a, 2), action = _b[0], apiData = _b[1];
            var e_1, _c;
            /** @type {?} */
            var apiDataGuid = null;
            try {
                for (var _d = __values(Object.keys(apiData)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var key = _e.value;
                    if (apiData[key].serializedRequestUrl === action.url) {
                        apiDataGuid = key;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (!apiDataGuid) {
                apiDataGuid = getUuid();
            }
            return { componentGuid: action.componentGuid, componentUrl: action.url, apiDataGuid: apiDataGuid };
        }), switchMap(function (res) { return [
            // Old syntax in order to allow .toBeObservable() operate as expected
            { apiEndpointGuid: res.apiDataGuid, apiEndpointUrl: res.componentUrl, type: ATTACH_API_DATA },
            { componentGuid: res.componentGuid, apiDataGuid: res.apiDataGuid, type: CONNECT_COMPONENT_WITH_API_DATA },
            { apiEndpointGuid: res.apiDataGuid, type: GET_API_DATA },
            { componentGuid: res.componentGuid, type: START_POLLING }
        ]; }));
        this.startPolling = this.actions$.pipe(ofType(START_POLLING), withLatestFrom(this.selectors.uiComponents$), mergeMap(function (_a) {
            var _b = __read(_a, 2), action = _b[0], componentData = _b[1];
            return componentData[action.componentGuid].polling
                ? timer(componentData[action.componentGuid].pollingInterval, componentData[action.componentGuid].pollingInterval).pipe(map(function (num) { return action; }))
                : EMPTY;
        }), withLatestFrom(this.selectors.uiComponents$), map(function (_a) {
            var _b = __read(_a, 2), action = _b[0], componentData = _b[1];
            return componentData[action.componentGuid];
        }), filter(function (componentInstance) { return componentInstance.polling; }), map(function (componentInstance) { return new GetApiData(componentInstance.endpointGuid); }));
        this.getApiData$ = this.actions$.pipe(ofType(GET_API_DATA), map(function (action) { return action.apiEndpointGuid; }), withLatestFrom(this.selectors.apiData$), mergeMap(function (_a) {
            var _b = __read(_a, 2), apiEndpointGuid = _b[0], apiData = _b[1];
            /** @type {?} */
            var currentEndpoint = apiData[apiEndpointGuid];
            return _this.apiResolverService.httpGet(currentEndpoint.serializedRequestUrl).pipe(map(function (res) { return { apiEndpointGuid: apiEndpointGuid, serializedUrl: currentEndpoint.serializedRequestUrl, data: res, type: SET_API_DATA }; }), catchError(function (error) { return of({ type: SET_API_DATA_ERROR }); }));
        }));
    }
    NsxUiEffects.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    NsxUiEffects.ctorParameters = function () { return [
        { type: Actions },
        { type: AppSelectors },
        { type: ApiResolverService }
    ]; };
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], NsxUiEffects.prototype, "attachComponent$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], NsxUiEffects.prototype, "startPolling", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], NsxUiEffects.prototype, "getApiData$", void 0);
    return NsxUiEffects;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} obj
 * @return {?}
 */
function cloneDeep(obj) {
    return JSON.parse(JSON.stringify(obj));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var MAX_RECORDS_TO_PRESERVE = 10;
/** @type {?} */
var initialState = {
    uiComponents: {},
    apiData: {}
};
/** @type {?} */
var appConfigReducers = {
    uiState: nsxGlobalReducer
};
/**
 * @param {?=} state
 * @param {?=} action
 * @return {?}
 */
function nsxGlobalReducer(state, action) {
    if (state === void 0) { state = initialState; }
    var _a, _b, _c, _d;
    switch (action.type) {
        case RESTART_POLLING: {
            /** @type {?} */
            var clonedUiComponents = cloneDeep(state.uiComponents);
            clonedUiComponents[action.componentGuid].polling = true;
            return __assign({}, state, { uiComponents: clonedUiComponents });
        }
        case START_POLLING: {
            /** @type {?} */
            var clonedUiComponents = cloneDeep(state.uiComponents);
            clonedUiComponents[action.componentGuid].polling = !!clonedUiComponents[action.componentGuid].pollingInterval;
            return __assign({}, state, { uiComponents: clonedUiComponents });
        }
        case STOP_POLLING: {
            /** @type {?} */
            var clonedUiComponents = cloneDeep(state.uiComponents);
            clonedUiComponents[action.componentGuid].polling = false;
            return __assign({}, state, { uiComponents: clonedUiComponents });
        }
        case ATTACH_COMPONENT: {
            return __assign({}, state, { uiComponents: __assign({}, state.uiComponents, (_a = {}, _a[action.componentGuid] = action.component, _a)) });
        }
        case DETACH_COMPONENT: {
            var _e = state.uiComponents, _f = action.componentGuid, value = _e[_f], rest = __rest(_e, [typeof _f === "symbol" ? _f : _f + ""]);
            return __assign({}, state, { uiComponents: __assign({}, rest) });
        }
        case ATTACH_API_DATA: {
            var _g = state.apiData, _h = action.apiEndpointGuid, value = _g[_h], rest = __rest(_g, [typeof _h === "symbol" ? _h : _h + ""]);
            /** @type {?} */
            var newApiDataItem = {
                data: [],
                lastUpdate: null,
                serializedRequestUrl: action.apiEndpointUrl
            };
            return __assign({}, state, { apiData: __assign({}, rest, (_b = {}, _b[action.apiEndpointGuid] = newApiDataItem, _b)) });
        }
        case SET_API_DATA: {
            var _j = state.apiData, _k = action.apiEndpointGuid, value = _j[_k], rest = __rest(_j, [typeof _k === "symbol" ? _k : _k + ""]);
            //Hold only 10 latest reocords within our state
            value.data = __spread((value.data.slice(-1 * (MAX_RECORDS_TO_PRESERVE - 1))), [action.data]);
            value.lastUpdate = new Date();
            value.serializedRequestUrl = action.serializedUrl;
            return __assign({}, state, { apiData: __assign({}, rest, (_c = {}, _c[action.apiEndpointGuid] = value, _c)) });
        }
        case CONNECT_COMPONENT_WITH_API_DATA: {
            var _l = state.uiComponents, _m = action.componentGuid, value = _l[_m], rest = __rest(_l, [typeof _m === "symbol" ? _m : _m + ""]);
            value.endpointGuid = action.apiDataGuid;
            return __assign({}, state, { uiComponents: __assign({}, rest, (_d = {}, _d[action.componentGuid] = value, _d)) });
        }
    }
    return state;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { INIT_COMPONENT, ATTACH_COMPONENT, DETACH_COMPONENT, CONNECT_COMPONENT_WITH_API_DATA, RESTART_POLLING, START_POLLING, STOP_POLLING, ATTACH_API_DATA, GET_API_DATA, SET_API_DATA, SET_API_DATA_ERROR, SET_API_DATA_SUCCESS, AttachComponent, DetachComponent, ConnectComponentWithApiData, RestartPolling, StartPolling, StopPolling, AttachApiData, GetApiData, SetApiData, SetApiDataError, SetApiDataSuccess, AppDispatchers, NsxUiEffects, nsxGlobalReducer, MAX_RECORDS_TO_PRESERVE, initialState, appConfigReducers, getAppState, getApiData, getUiComponentData, AppSelectors };

//# sourceMappingURL=kissmybutton-nsx-ui-state-lib.js.map